import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import Storage from '@tencent/vft-common/Storage';
import SvgIcons from '@tencent/vft-ui/src/SvgIcons/SvgIcons.vue';
import Avatar from '@vip-activity/ui/components/Avatar/Avatar.vue';
import MagicService from '../../../src/service/magic';
var KEY = 'ysf-lxky-friend-pop';
export default {
  components: {
    SvgIcons: SvgIcons,
    Avatar: Avatar
  },
  data: function data() {
    return {};
  },
  computed: _objectSpread({}, mapState(['orderList'])),
  watch: {
    orderList: function orderList() {
      this.checkFriendTips();
    }
  },
  mounted: function mounted() {
    this.checkFriendTips();
  },
  methods: {
    checkFriendTips: function checkFriendTips() {
      var _orderItem$ReceiveLis, _orderItem$ReceiveLis2;

      var _this$orderList = _slicedToArray(this.orderList, 1),
          orderItem = _this$orderList[0];

      if (!orderItem) return;
      var sVal = Storage.get(KEY);
      var val = "".concat(orderItem.order_id, "-").concat((_orderItem$ReceiveLis = orderItem.ReceiveList) === null || _orderItem$ReceiveLis === void 0 ? void 0 : _orderItem$ReceiveLis.length);

      if (sVal !== val && (_orderItem$ReceiveLis2 = orderItem.ReceiveList) !== null && _orderItem$ReceiveLis2 !== void 0 && _orderItem$ReceiveLis2.length) {
        Storage.set(KEY, val);
        this.showFriend(orderItem);
      }
    },
    showFriend: function showFriend(item) {
      this.eventBus.$emit('showReceive', (item.ReceiveList || []).map(function (i) {
        return i;
      }));
    },
    // eslint-disable-next-line camelcase
    share: function share(_ref) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var order_id, remainNum, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                order_id = _ref.order_id, remainNum = _ref.remain_num;
                _context.next = 3;
                return MagicService.getShareToken({
                  order_id: order_id
                }).catch(function (e) {
                  var code = e.code;

                  if (code === -1019) {
                    _this.eventBus.$emit('refreshTicketInfo');

                    _this.toast('您的套票已经被抢光了');
                  } else {
                    _this.toast("\u670D\u52A1\u5668\u5F00\u5C0F\u5DEE\u4E86[".concat(e.code, "]"));
                  }

                  return Promise.reject(e);
                });

              case 3:
                res = _context.sent;

                if (res && res.ret === 0) {
                  _this.eventBus.$emit('launchShare', {
                    mode: 'zs',
                    token: res.token,
                    count: remainNum,
                    label: "\u9001\u51FA".concat(remainNum, "\u4EFD")
                  });
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};